import {
  type Maybe,
  type User,
  type WorkflowCompletion,
  WorkflowObjectTypes,
} from '@generated/graphql';

export type WorkflowCompletionIdentity = Partial<
  Pick<WorkflowCompletion, 'objectType' | 'objectId'>
> & {
  user?: Maybe<Pick<User, 'stringId'>>;
  householdPrimaryUserId?: Maybe<string>;
};

const nonEmpty = (id: Maybe<string> | undefined) => id || undefined;

// objectId is a user id only for USER completions. For HOUSEHOLD it is a
// client group id, so it must never be returned as a user id.
export const resolveWorkflowCompletionUserId = ({
  objectType,
  objectId,
  user,
  householdPrimaryUserId,
}: WorkflowCompletionIdentity) => {
  const ownerId = nonEmpty(user?.stringId);
  if (ownerId) return ownerId;

  if (objectType === WorkflowObjectTypes.User) return nonEmpty(objectId);
  if (objectType === WorkflowObjectTypes.Household)
    return nonEmpty(householdPrimaryUserId);
  return undefined;
};
